/**
 * Approved Song Library Actions column icons (Bootstrap Icons).
 * Keep these as the single source of truth — do not substitute emoji glyphs.
 */
export const SONG_LIBRARY_ACTION_ICONS = {
  play: "bi bi-play-circle",
  pause: "bi bi-pause-circle",
  viewProcessing: "bi bi-cpu",
  replaceAudio: "bi bi-arrow-repeat",
  archive: "bi bi-archive",
  restore: "bi bi-arrow-counterclockwise",
  permanentDelete: "bi bi-trash3",
  editGenre: "bi bi-tags",
} as const;

export type SongLibraryActionIcon =
  (typeof SONG_LIBRARY_ACTION_ICONS)[keyof typeof SONG_LIBRARY_ACTION_ICONS];
